import { createSelector } from 'reselect';
import { socialProofPDPSelector } from 'selectors/testTarget/offers/socialProofPDP/socialProofPDPSelector';

const experienceSelector = createSelector(socialProofPDPSelector, socialProofPDP => socialProofPDP.experience);

export { experienceSelector };
